var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-controls" }, [
    _c("div", { staticClass: "c-controls__group" }, [
      _c("label", { staticClass: "c-controls__label" }, [_vm._v("Timer")]),
      _vm._v(" "),
      _c("div", { staticClass: "c-videocontrols" }, [
        _c(
          "button",
          {
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.startTimer.apply(null, arguments)
              }
            }
          },
          [
            _c("svg", { staticClass: "icon icon_play" }, [
              _c("use", { attrs: { "xlink:href": "#icon_play" } })
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.pauseTimer.apply(null, arguments)
              }
            }
          },
          [
            _c("svg", { staticClass: "icon icon_pause" }, [
              _c("use", { attrs: { "xlink:href": "#icon_pause" } })
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.stopTimer.apply(null, arguments)
              }
            }
          },
          [
            _c("svg", { staticClass: "icon icon_stop" }, [
              _c("use", { attrs: { "xlink:href": "#icon_stop" } })
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }